import React, { useState, useEffect } from 'react';

const escapeHtml = (text) => {
  if (text === null || text === undefined) return '';
  const str = String(text);
  const htmlEntities = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };
  return str.replace(/[&<>"'`=/]/g, char => htmlEntities[char]);
};

const OrdersAdmin = ({ API, adminToken, isDarkMode, showNotification }) => {
  const authHeaders = {
    'Authorization': `Bearer ${adminToken}`,
    'Content-Type': 'application/json'
  };
  const authHeadersForForm = {
    'Authorization': `Bearer ${adminToken}`
  };

  const [orders, setOrders] = useState([]);
  const [orderFilters, setOrderFilters] = useState({ status: '', plan_name: '', search: '' });

  const loadOrders = async () => {
    try {
      const response = await fetch(`${API}/admin/orders`, {
        headers: authHeaders
      });
      if (response.ok) {
        const data = await response.json();
        setOrders(data);
      }
    } catch (error) {
      console.error('Error loading orders:', error);
    }
  };

  useEffect(() => {
    loadOrders();
  }, []);

  return (
                <div className="space-y-6">
                  {/* Summary Stats Cards */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className={`p-6 rounded-xl shadow-lg ${isDarkMode ? 'bg-gradient-to-br from-blue-900 to-blue-800' : 'bg-gradient-to-br from-blue-50 to-blue-100'}`}>
                      <p className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-blue-200' : 'text-blue-700'}`}>Total Orders</p>
                      <p className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-blue-900'}`}>{orders.length}</p>
                    </div>
                    <div className={`p-6 rounded-xl shadow-lg ${isDarkMode ? 'bg-gradient-to-br from-green-900 to-green-800' : 'bg-gradient-to-br from-green-50 to-green-100'}`}>
                      <p className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-green-200' : 'text-green-700'}`}>Total Revenue</p>
                      <p className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-green-900'}`}>
                        ${orders.reduce((sum, o) => sum + (o.amount || 0), 0).toFixed(2)}
                      </p>
                    </div>
                    <div className={`p-6 rounded-xl shadow-lg ${isDarkMode ? 'bg-gradient-to-br from-purple-900 to-purple-800' : 'bg-gradient-to-br from-purple-50 to-purple-100'}`}>
                      <p className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-purple-200' : 'text-purple-700'}`}>Active Memberships</p>
                      <p className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-purple-900'}`}>
                        {orders.filter(o => o.status === 'completed').length}
                      </p>
                    </div>
                    <div className={`p-6 rounded-xl shadow-lg ${isDarkMode ? 'bg-gradient-to-br from-orange-900 to-orange-800' : 'bg-gradient-to-br from-orange-50 to-orange-100'}`}>
                      <p className={`text-sm font-semibold mb-2 ${isDarkMode ? 'text-orange-200' : 'text-orange-700'}`}>Recent Orders (30d)</p>
                      <p className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-orange-900'}`}>
                        {orders.filter(o => {
                          const orderDate = new Date(o.created_at);
                          const thirtyDaysAgo = new Date();
                          thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                          return orderDate >= thirtyDaysAgo;
                        }).length}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <h3 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
                      🛒 Order History
                    </h3>
                    <div className="flex gap-2">
                      <button
                        onClick={() => {
                          // Show create order modal
                          const modal = document.createElement('div');
                          modal.innerHTML = `
                            <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onclick="this.remove()">
                              <div class="bg-white dark:bg-gray-800 p-6 rounded-xl max-w-md w-full" onclick="event.stopPropagation()">
                                <h3 class="text-xl font-bold mb-4 dark:text-white">Create Manual Order</h3>
                                <form id="createOrderForm" class="space-y-4">
                                  <div>
                                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">User Email</label>
                                    <input type="email" name="user_email" required class="w-full px-3 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white" placeholder="user@example.com">
                                  </div>
                                  <div>
                                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">Plan</label>
                                    <select name="plan_id" required class="w-full px-3 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                      <option value="">Select Plan</option>
                                    </select>
                                  </div>
                                  <div>
                                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">Amount ($)</label>
                                    <input type="number" step="0.01" name="amount" required class="w-full px-3 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white" placeholder="1.99">
                                  </div>
                                  <div>
                                    <label class="block text-sm font-medium mb-1 dark:text-gray-300">Payment Method</label>
                                    <select name="payment_method" class="w-full px-3 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                      <option value="manual">Manual/Cash</option>
                                      <option value="bank_transfer">Bank Transfer</option>
                                      <option value="other">Other</option>
                                    </select>
                                  </div>
                                  <div class="flex gap-2">
                                    <button type="submit" class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Create Order</button>
                                    <button type="button" onclick="this.closest('.fixed').remove()" class="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600">Cancel</button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          `;
                          document.body.appendChild(modal);

                          // Load plans
                          fetch(`${API}/admin/membership/plans`, {
                            headers: { Authorization: `Bearer ${adminToken}` }
                          }).then(r => r.json()).then(plans => {
                            const select = modal.querySelector('[name="plan_id"]');
                            plans.forEach(plan => {
                              if (plan.name !== 'free') {
                                const option = document.createElement('option');
                                option.value = plan.id;
                                option.textContent = `${plan.display_name} - $${plan.price}`;
                                select.appendChild(option);
                              }
                            });
                          });

                          // Handle form submit
                          modal.querySelector('#createOrderForm').addEventListener('submit', async (e) => {
                            e.preventDefault();
                            const formData = new FormData(e.target);

                            // Find user by email
                            const usersRes = await fetch(`${API}/admin/membership/users`, {
                              headers: { Authorization: `Bearer ${adminToken}` }
                            });
                            const users = await usersRes.json();
                            const user = users.find(u => u.email === formData.get('user_email'));

                            if (!user) {
                              showNotification('User not found with that email', 'error');
                              return;
                            }

                            // Create order
                            const orderData = new FormData();
                            orderData.append('user_id', user.id);
                            orderData.append('plan_id', formData.get('plan_id'));
                            orderData.append('amount', formData.get('amount'));
                            orderData.append('payment_method', formData.get('payment_method'));

                            const response = await fetch(`${API}/admin/orders`, {
                              method: 'POST',
                              headers: { Authorization: `Bearer ${adminToken}` },
                              body: orderData
                            });

                            if (response.ok) {
                              showNotification('Order created successfully!', 'success');
                              modal.remove();
                              loadOrders(); // Reload orders
                            } else {
                              const error = await response.json();
                              showNotification(error.detail || 'Failed to create order', 'error');
                            }
                          });
                        }}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                      >
                        ➕ Create Order
                      </button>
                      <button
                        onClick={async () => {
                          // Export to CSV
                          const csv = [
                            ['Order #', 'Customer', 'Email', 'Plan', 'Amount', 'Status', 'Date'].join(','),
                            ...orders.map(o => [
                              o.order_number,
                              o.user_name,
                              o.user_email,
                              o.plan_display_name,
                              `$${o.amount}`,
                              o.status,
                              new Date(o.created_at).toLocaleDateString()
                            ].join(','))
                          ].join('\n');

                          const blob = new Blob([csv], { type: 'text/csv' });
                          const url = URL.createObjectURL(blob);
                          const a = document.createElement('a');
                          a.href = url;
                          a.download = `orders_${new Date().toISOString().split('T')[0]}.csv`;
                          a.click();
                          showNotification('Orders exported successfully!', 'success');
                        }}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                      >
                        📥 Export CSV
                      </button>
                    </div>
                  </div>

                  {/* Filters */}
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                    <input
                      type="text"
                      placeholder="Search by name or email..."
                      value={orderFilters.search}
                      onChange={(e) => setOrderFilters({...orderFilters, search: e.target.value})}
                      className={`px-4 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                    <select
                      value={orderFilters.status}
                      onChange={(e) => setOrderFilters({...orderFilters, status: e.target.value})}
                      className={`px-4 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="">All Status</option>
                      <option value="completed">Completed</option>
                      <option value="pending">Pending</option>
                      <option value="failed">Failed</option>
                      <option value="refunded">Refunded</option>
                    </select>
                    <select
                      value={orderFilters.plan_name}
                      onChange={(e) => setOrderFilters({...orderFilters, plan_name: e.target.value})}
                      className={`px-4 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="">All Plans</option>
                      <option value="monthly">Monthly Pro</option>
                      <option value="yearly">Yearly Pro</option>
                    </select>
                    <select
                      value={orderFilters.dateRange || 'all'}
                      onChange={(e) => setOrderFilters({...orderFilters, dateRange: e.target.value})}
                      className={`px-4 py-2 border rounded-lg ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="all">All Time</option>
                      <option value="30">Last 30 Days</option>
                      <option value="60">Last 60 Days</option>
                      <option value="90">Last 90 Days</option>
                    </select>
                    <button
                      onClick={async () => {
                        const response = await fetch(`${API}/admin/orders`, {
                          headers: { Authorization: `Bearer ${adminToken}` }
                        });
                        const data = await response.json();
                        setOrders(data);
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      🔄 Refresh
                    </button>
                  </div>

                  {/* Orders Table - Modern Responsive Design */}
                  <div className="space-y-4">
                    {/* Desktop Table View */}
                    <div className="hidden md:block overflow-x-auto rounded-xl shadow-lg">
                      <table className="w-full">
                        <thead className={`${isDarkMode ? 'bg-gradient-to-r from-gray-800 to-gray-700' : 'bg-gradient-to-r from-blue-50 to-purple-50'}`}>
                          <tr>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Order #</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Customer</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Plan</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Amount</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Status</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Created</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Expires</th>
                            <th className={`px-6 py-4 text-left text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Method</th>
                            <th className={`px-6 py-4 text-center text-xs font-bold ${isDarkMode ? 'text-gray-200' : 'text-gray-700'} uppercase tracking-wider`}>Actions</th>
                          </tr>
                        </thead>
                        <tbody className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} divide-y ${isDarkMode ? 'divide-gray-700' : 'divide-gray-100'}`}>
                          {orders
                            .filter(o => {
                              // Only show paid users (exclude free plans)
                              if (o.plan_name === 'free' || o.plan_display_name?.toLowerCase().includes('free')) return false;

                              if (orderFilters.search &&
                                  !(o.user_name || '').toLowerCase().includes(orderFilters.search.toLowerCase()) &&
                                  !(o.user_email || '').toLowerCase().includes(orderFilters.search.toLowerCase()) &&
                                  !o.order_number?.toLowerCase().includes(orderFilters.search.toLowerCase())) return false;
                              if (orderFilters.status && o.status !== orderFilters.status) return false;
                              if (orderFilters.plan_name && o.plan_name !== orderFilters.plan_name) return false;
                              if (orderFilters.dateRange && orderFilters.dateRange !== 'all') {
                                const orderDate = new Date(o.created_at);
                                const daysAgo = new Date();
                                daysAgo.setDate(daysAgo.getDate() - parseInt(orderFilters.dateRange));
                                if (orderDate < daysAgo) return false;
                              }
                              return true;
                            })
                            .map((order) => (
                            <tr key={order.id} className={`transition-colors ${isDarkMode ? 'hover:bg-gray-700/50' : 'hover:bg-blue-50/50'}`}>
                              <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>
                                <div className="flex items-center space-x-2">
                                  {order.payment_method === 'manual' ? (
                                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${isDarkMode ? 'bg-orange-900/40 text-orange-300 border border-orange-700' : 'bg-orange-100 text-orange-700 border border-orange-300'}`}>
                                      📝 MANUAL
                                    </span>
                                  ) : (
                                    <span className="font-mono font-semibold text-blue-600 dark:text-blue-400">{order.order_number}</span>
                                  )}
                                </div>
                              </td>
                              <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>
                                <div className="flex items-center space-x-3">
                                  <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${isDarkMode ? 'bg-gradient-to-br from-purple-600 to-pink-600' : 'bg-gradient-to-br from-blue-500 to-purple-500'}`}>
                                    {(order.user_name || 'U').charAt(0).toUpperCase()}
                                  </div>
                                  <div>
                                    <p className="font-semibold">{order.user_name || 'Unknown'}</p>
                                    <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{order.user_email || 'No email'}</p>
                                  </div>
                                </div>
                              </td>
                              <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}`}>
                                <span className={`px-3 py-1.5 rounded-lg font-semibold ${
                                  order.plan_name === 'monthly' ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white' :
                                  order.plan_name === 'yearly' ? 'bg-gradient-to-r from-green-500 to-teal-500 text-white' :
                                  isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                                }`}>
                                  {order.plan_display_name || 'Unknown'}
                                </span>
                              </td>
                              <td className={`px-6 py-4 text-sm font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>
                                <div className="flex items-center space-x-1">
                                  <span className="text-lg">$</span>
                                  <span className="text-xl">{(order.amount || 0).toFixed(2)}</span>
                                </div>
                              </td>
                              <td className="px-6 py-4 text-sm">
                                <span className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide ${
                                  order.status === 'completed' ? 'bg-green-500 text-white shadow-lg shadow-green-500/50' :
                                  order.status === 'pending' ? 'bg-yellow-500 text-white shadow-lg shadow-yellow-500/50' :
                                  order.status === 'failed' ? 'bg-red-500 text-white shadow-lg shadow-red-500/50' :
                                  order.status === 'cancelled' ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/50' :
                                  order.status === 'refunded' ? 'bg-purple-500 text-white shadow-lg shadow-purple-500/50' :
                                  'bg-gray-500 text-white'
                                }`}>
                                  {order.status || 'Unknown'}
                                </span>
                              </td>
                              <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                <div className="flex flex-col">
                                  <span className="font-semibold">{order.created_at ? new Date(order.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Unknown'}</span>
                                  <span className="text-xs">{order.created_at ? new Date(order.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : ''}</span>
                                </div>
                              </td>
                              <td className={`px-6 py-4 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                <div className="flex flex-col">
                                  <span className="font-semibold">{order.expiration_date ? new Date(order.expiration_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'N/A'}</span>
                                  {order.expiration_date && (
                                    <span className={`text-xs ${new Date(order.expiration_date) < new Date() ? 'text-red-500 font-bold' : 'text-gray-500'}`}>
                                      {new Date(order.expiration_date) < new Date() ? '⚠️ Expired' : '✓ Active'}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <span className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold ${
                                  (order.acquisition_method === 'admin_granted' || order.payment_method === 'admin' || order.payment_method === 'manual')
                                    ? isDarkMode ? 'bg-orange-900/40 text-orange-300' : 'bg-orange-100 text-orange-700'
                                    : isDarkMode ? 'bg-blue-900/40 text-blue-300' : 'bg-blue-100 text-blue-700'
                                }`}>
                                  {(order.acquisition_method === 'admin_granted' || order.payment_method === 'admin' || order.payment_method === 'manual') ? '👤 Admin Granted' : '💳 Purchase'}
                                </span>
                              </td>
                              <td className="px-6 py-4 text-sm">
                                <div className="flex items-center justify-center space-x-2">
                                  {/* Edit Button */}
                                  <button
                                    onClick={() => {
                                      // Edit Order Modal - escape user data to prevent XSS
                                      const safeEmail = escapeHtml(order.user_email || 'No email');
                                      const safeName = escapeHtml(order.user_name || 'Unknown');
                                      const safeAmount = escapeHtml(String(order.amount || 0));
                                      const safeStatus = escapeHtml(order.status || 'pending');
                                      const safeExpDate = order.expiration_date ? new Date(order.expiration_date).toISOString().split('T')[0] : '';

                                      const modal = document.createElement('div');
                                      modal.innerHTML = `
                                        <div class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4" onclick="this.remove()">
                                          <div class="${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-8 rounded-2xl max-w-lg w-full shadow-2xl" onclick="event.stopPropagation()">
                                            <h3 class="text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}">✏️ Edit Order</h3>
                                            <div class="mb-6 p-4 rounded-xl ${isDarkMode ? 'bg-blue-900/30 border border-blue-700' : 'bg-blue-50 border border-blue-200'}">
                                              <p class="text-sm font-medium ${isDarkMode ? 'text-blue-300' : 'text-blue-700'} mb-1">Customer Email:</p>
                                              <p class="text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}">${safeEmail}</p>
                                              <p class="text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mt-1">${safeName}</p>
                                            </div>
                                            <form id="editOrderForm" class="space-y-4">
                                              <div>
                                                <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Order Status</label>
                                                <select name="status" required class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                                  <option value="completed" ${safeStatus === 'completed' ? 'selected' : ''}>Completed</option>
                                                  <option value="pending" ${safeStatus === 'pending' ? 'selected' : ''}>Pending</option>
                                                  <option value="failed" ${safeStatus === 'failed' ? 'selected' : ''}>Failed</option>
                                                  <option value="refunded" ${safeStatus === 'refunded' ? 'selected' : ''}>Refunded</option>
                                                </select>
                                              </div>
                                              <div>
                                                <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Amount ($)</label>
                                                <input type="number" step="0.01" name="amount" value="${safeAmount}" required class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                              </div>
                                              <div>
                                                <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Expiration Date</label>
                                                <input type="date" name="expiration_date" value="${safeExpDate}" class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                              </div>
                                              <div class="flex gap-3 mt-6">
                                                <button type="submit" class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 font-bold shadow-lg">Save Changes</button>
                                                <button type="button" onclick="this.closest('.fixed').remove()" class="px-6 py-3 ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'} rounded-xl font-semibold">Cancel</button>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      `;
                                      document.body.appendChild(modal);

                                      modal.querySelector('#editOrderForm').addEventListener('submit', async (e) => {
                                        e.preventDefault();
                                        const formData = new FormData(e.target);

                                        try {
                                          const response = await fetch(`${API}/admin/orders/${order.id}`, {
                                            method: 'PUT',
                                            headers: { Authorization: `Bearer ${adminToken}` },
                                            body: formData
                                          });

                                          if (response.ok) {
                                            showNotification('Order updated successfully!', 'success');
                                            modal.remove();
                                            loadOrders(); // Reload orders
                                          } else {
                                            const error = await response.json();
                                            showNotification(error.detail || 'Failed to update order', 'error');
                                          }
                                        } catch (error) {
                                          showNotification('Error updating order', 'error');
                                        }
                                      });
                                    }}
                                    className={`px-4 py-2 rounded-lg font-semibold transition-all transform hover:scale-105 ${isDarkMode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-blue-500 hover:bg-blue-600'} text-white shadow-md`}
                                    title="Edit order"
                                  >
                                    ✏️ Edit
                                  </button>
                                  <button
                                    onClick={async () => {
                                      if (window.confirm(`⚠️ Are you sure you want to delete ${order.payment_method === 'manual' ? 'this manual order' : order.order_number}?\n\nThis action cannot be undone.`)) {
                                        try {
                                          const response = await fetch(`${API}/admin/orders/${order.id}`, {
                                            method: 'DELETE',
                                            headers: { Authorization: `Bearer ${adminToken}` }
                                          });

                                          if (response.ok) {
                                            showNotification('Order deleted successfully!', 'success');
                                            loadOrders();
                                          } else {
                                            const error = await response.json();
                                            showNotification(error.detail || 'Failed to delete order', 'error');
                                          }
                                        } catch (error) {
                                          showNotification('Error deleting order', 'error');
                                        }
                                      }
                                    }}
                                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-all transform hover:scale-105 shadow-md"
                                    title="Delete order"
                                  >
                                    🗑️ Delete
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Mobile Card View */}
                    <div className="md:hidden space-y-4">
                      {orders
                        .filter(o => {
                          // Only show paid users (exclude free plans)
                          if (o.plan_name === 'free' || o.plan_display_name?.toLowerCase().includes('free')) return false;

                          if (orderFilters.search &&
                              !o.user_name.toLowerCase().includes(orderFilters.search.toLowerCase()) &&
                              !o.user_email.toLowerCase().includes(orderFilters.search.toLowerCase()) &&
                              !o.order_number?.toLowerCase().includes(orderFilters.search.toLowerCase())) return false;
                          if (orderFilters.status && o.status !== orderFilters.status) return false;
                          if (orderFilters.plan_name && o.plan_name !== orderFilters.plan_name) return false;
                          return true;
                        })
                        .map((order) => (
                        <div key={order.id} className={`p-6 rounded-2xl shadow-lg ${isDarkMode ? 'bg-gray-800 border border-gray-700' : 'bg-white border border-gray-200'}`}>
                          <div className="flex items-start justify-between mb-4">
                            <div className="flex items-center space-x-3">
                              <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-white ${isDarkMode ? 'bg-gradient-to-br from-purple-600 to-pink-600' : 'bg-gradient-to-br from-blue-500 to-purple-500'}`}>
                                {(order.user_name || 'U').charAt(0).toUpperCase()}
                              </div>
                              <div>
                                <p className={`font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{order.user_name || 'Unknown'}</p>
                                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{order.user_email || 'No email'}</p>
                              </div>
                            </div>
                            <span className={`px-3 py-1 rounded-full text-xs font-bold ${
                              order.status === 'completed' ? 'bg-green-500 text-white' :
                              order.status === 'pending' ? 'bg-yellow-500 text-white' :
                              order.status === 'failed' ? 'bg-red-500 text-white' :
                              'bg-gray-500 text-white'
                            }`}>
                              {order.status}
                            </span>
                          </div>

                          <div className="space-y-3 mb-4">
                            <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Order:</span>
                              {order.payment_method === 'manual' ? (
                                <span className={`px-3 py-1 rounded-full text-xs font-bold ${isDarkMode ? 'bg-orange-900/40 text-orange-300' : 'bg-orange-100 text-orange-700'}`}>
                                  📝 MANUAL
                                </span>
                              ) : (
                                <span className={`font-mono font-semibold ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>{order.order_number}</span>
                              )}
                            </div>
                            <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Plan:</span>
                              <span className={`px-3 py-1 rounded-lg font-semibold text-sm ${
                                order.plan_name === 'monthly' ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white' :
                                order.plan_name === 'yearly' ? 'bg-gradient-to-r from-green-500 to-teal-500 text-white' :
                                isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'
                              }`}>
                                {order.plan_display_name}
                              </span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Amount:</span>
                              <span className={`text-2xl font-bold ${isDarkMode ? 'text-green-400' : 'text-green-600'}`}>${(order.amount || 0).toFixed(2)}</span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Created:</span>
                              <span className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {order.created_at ? new Date(order.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'Unknown'}
                              </span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Expires:</span>
                              <span className={`text-sm font-semibold ${new Date(order.expiration_date) < new Date() ? 'text-red-500' : isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                {order.expiration_date ? new Date(order.expiration_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : 'N/A'}
                              </span>
                            </div>
                          </div>

                          <div className="flex gap-2 pt-4 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}">
                            <button
                              onClick={() => {
                                // Same edit modal as desktop - escape user data to prevent XSS
                                const safeEmail = escapeHtml(order.user_email || 'No email');
                                const safeName = escapeHtml(order.user_name || 'Unknown');
                                const safeAmount = escapeHtml(String(order.amount || 0));
                                const safeStatus = escapeHtml(order.status || 'pending');
                                const safeExpDate = order.expiration_date ? new Date(order.expiration_date).toISOString().split('T')[0] : '';

                                const modal = document.createElement('div');
                                modal.innerHTML = `
                                  <div class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4" onclick="this.remove()">
                                    <div class="${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-8 rounded-2xl max-w-lg w-full shadow-2xl" onclick="event.stopPropagation()">
                                      <h3 class="text-2xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}">✏️ Edit Order</h3>
                                      <div class="mb-6 p-4 rounded-xl ${isDarkMode ? 'bg-blue-900/30 border border-blue-700' : 'bg-blue-50 border border-blue-200'}">
                                        <p class="text-sm font-medium ${isDarkMode ? 'text-blue-300' : 'text-blue-700'} mb-1">Customer Email:</p>
                                        <p class="text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}">${safeEmail}</p>
                                        <p class="text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'} mt-1">${safeName}</p>
                                      </div>
                                      <form id="editOrderFormMobile" class="space-y-4">
                                        <div>
                                          <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Order Status</label>
                                          <select name="status" required class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                            <option value="completed" ${safeStatus === 'completed' ? 'selected' : ''}>Completed</option>
                                            <option value="pending" ${safeStatus === 'pending' ? 'selected' : ''}>Pending</option>
                                            <option value="failed" ${safeStatus === 'failed' ? 'selected' : ''}>Failed</option>
                                            <option value="refunded" ${safeStatus === 'refunded' ? 'selected' : ''}>Refunded</option>
                                          </select>
                                        </div>
                                        <div>
                                          <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Amount ($)</label>
                                          <input type="number" step="0.01" name="amount" value="${safeAmount}" required class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                        </div>
                                        <div>
                                          <label class="block text-sm font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}">Expiration Date</label>
                                          <input type="date" name="expiration_date" value="${safeExpDate}" class="w-full px-4 py-3 border-2 rounded-xl ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500">
                                        </div>
                                        <div class="flex gap-3 mt-6">
                                          <button type="submit" class="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 font-bold shadow-lg">Save Changes</button>
                                          <button type="button" onclick="this.closest('.fixed').remove()" class="px-6 py-3 ${isDarkMode ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-200 hover:bg-gray-300'} rounded-xl font-semibold">Cancel</button>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                `;
                                document.body.appendChild(modal);

                                modal.querySelector('#editOrderFormMobile').addEventListener('submit', async (e) => {
                                  e.preventDefault();
                                  const formData = new FormData(e.target);

                                  try {
                                    const response = await fetch(`${API}/admin/orders/${order.id}`, {
                                      method: 'PUT',
                                      headers: { Authorization: `Bearer ${adminToken}` },
                                      body: formData
                                    });

                                    if (response.ok) {
                                      showNotification('Order updated successfully!', 'success');
                                      modal.remove();
                                      loadOrders();
                                    } else {
                                      const error = await response.json();
                                      showNotification(error.detail || 'Failed to update order', 'error');
                                    }
                                  } catch (error) {
                                    showNotification('Error updating order', 'error');
                                  }
                                });
                              }}
                              className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold"
                            >
                              ✏️ Edit
                            </button>
                            <button
                              onClick={async () => {
                                if (window.confirm(`Delete ${order.payment_method === 'manual' ? 'manual order' : order.order_number}?`)) {
                                  try {
                                    const response = await fetch(`${API}/admin/orders/${order.id}`, {
                                      method: 'DELETE',
                                      headers: { Authorization: `Bearer ${adminToken}` }
                                    });
                                    if (response.ok) {
                                      showNotification('Deleted successfully!', 'success');
                                      loadOrders();
                                    }
                                  } catch (error) {
                                    showNotification('Error deleting', 'error');
                                  }
                                }
                              }}
                              className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl font-semibold"
                            >
                              🗑️ Delete
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {orders.length === 0 && (
                    <div className={`text-center py-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                      <p className="text-lg mb-2">🛒 No orders yet</p>
                      <p className="text-sm">Orders will appear here when users purchase subscriptions</p>
                    </div>
                  )}
                </div>
  );
};

export default OrdersAdmin;
